import useQueryParams from './useQueryParams'

/**
 * Google's raw stored rate-rule ID for the current metasearch landing context.
 *
 * Read from the URL query, mirroring {@link useMetasearchPriceId} (`gpid`) — the two travel
 * together on every discount-capable link (landing page and offer/Book Now URLs). Forwarded
 * verbatim; never parsed, normalised, or defaulted. Absent param → `undefined`, so absence stays
 * absent at the API boundary.
 */
export default function useMetasearchRuleId(): string | undefined {
  const query = useQueryParams()

  return query.get('ruleId') ?? undefined
}
